// extracted by mini-css-extract-plugin
module.exports = {"OrganigramaMunicipal":"OrganigramaMunicipal_OrganigramaMunicipal__1hA2y"};